export default class SimpleMessageModalModel {
    constructor(
        public Title: string,
        public Message: string,
        public onHide: ()=>void
    ) { }
}